'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var dagPb = require('@ipld/dag-pb');

var hamtShardedDirectoryContent = function hamtShardedDirectoryContent(cid, node, unixfs, path, resolve, depth, blockstore) {
  function yieldHamtDirectoryContent() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return listDirectory(node, path, resolve, depth, blockstore, options);
  }

  return yieldHamtDirectoryContent;
};

function listDirectory(_x, _x2, _x3, _x4, _x5, _x6) {
  return _listDirectory.apply(this, arguments);
}

function _listDirectory() {
  _listDirectory = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node, path, resolve, depth, blockstore, options) {
    var links, _iterator2, _step2, link, name, result, block, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, file;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            links = node.Links;
            _iterator2 = _createForOfIteratorHelper(links);
            _context.prev = 2;

            _iterator2.s();

          case 4:
            if ((_step2 = _iterator2.n()).done) {
              _context.next = 50;
              break;
            }

            link = _step2.value;
            name = link.Name != null ? link.Name.substring(2) : null;

            if (!name) {
              _context.next = 15;
              break;
            }

            _context.next = 10;
            return _awaitAsyncGenerator(resolve(link.Hash, name, "".concat(path, "/").concat(name), [], depth + 1, blockstore, options));

          case 10:
            result = _context.sent;
            _context.next = 13;
            return result.entry;

          case 13:
            _context.next = 48;
            break;

          case 15:
            _context.next = 17;
            return _awaitAsyncGenerator(blockstore.get(link.Hash));

          case 17:
            block = _context.sent;
            node = dagPb.decode(block);
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 21;
            _iterator = _asyncIterator(listDirectory(node, path, resolve, depth, blockstore, options));

          case 23:
            _context.next = 25;
            return _awaitAsyncGenerator(_iterator.next());

          case 25:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 32;
              break;
            }

            file = _step.value;
            _context.next = 29;
            return file;

          case 29:
            _iteratorAbruptCompletion = false;
            _context.next = 23;
            break;

          case 32:
            _context.next = 38;
            break;

          case 34:
            _context.prev = 34;
            _context.t0 = _context["catch"](21);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 38:
            _context.prev = 38;
            _context.prev = 39;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 43;
              break;
            }

            _context.next = 43;
            return _awaitAsyncGenerator(_iterator.return());

          case 43:
            _context.prev = 43;

            if (!_didIteratorError) {
              _context.next = 46;
              break;
            }

            throw _iteratorError;

          case 46:
            return _context.finish(43);

          case 47:
            return _context.finish(38);

          case 48:
            _context.next = 4;
            break;

          case 50:
            _context.next = 55;
            break;

          case 52:
            _context.prev = 52;
            _context.t1 = _context["catch"](2);

            _iterator2.e(_context.t1);

          case 55:
            _context.prev = 55;

            _iterator2.f();

            return _context.finish(55);

          case 58:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 52, 55, 58], [21, 34, 38, 48], [39,, 43, 47]]);
  }));
  return _listDirectory.apply(this, arguments);
}

module.exports = hamtShardedDirectoryContent;